import { VALIDATION_RULES } from "@lib/constants/formValidations";
import { companyMaxLength } from "@config/site/site-config";

const commonReplacements = {
    maxEmailCharacters: { maxCharacters: VALIDATION_RULES.email.maxCharacters },
    maxNameCharacters: { maxCharacters: 25 },
    maxCompanyCharacters: { maxCharacters: companyMaxLength },
    maxPhoneCharacters: { maxCharacters: 15 },
    maxCountryCodeCharacters: { maxCharacters: 3 },
    maxAddressCharacters: { maxCharacters: 40 },
};

export default commonReplacements;
